<template>
  <strong class="d-block text-center text-red">未設定</strong>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>
